import { Component } from '@angular/core';
import { WaitingIndicatorService } from '../../core-services/WaitingIndicator.service';
import { Util } from '../../core-utilities/Util';

@Component({
    selector: 'waitScreen',
    template: `
        @if (coordinator.isTagWaiting(waitTag)) {
            <loading-dots> </loading-dots>
        }
    `,
    standalone: false
})
export class WaitingIndicatorComponent {
    public waitTag: string;

    constructor(
        public coordinator: WaitingIndicatorService,
        private util: Util
    ) {
        this.waitTag = this.util.id.getGuid();
    }
}
